module.exports = __webpack_public_path__ + "img/database-and-server-side.11460591.png";